export const BIDDING_SUMMARY_EXPORT_STRIP_ICON_SELECTORS = [
  '.summary-accordion-head-icon',
  '.summary-accordion-chevron',
  '.summary-stat-icon-img',
  '.summary-stat-icon',
] as const;

export const BIDDING_SUMMARY_EXPORT_STRIP_EXTRA_SELECTORS = [
  '.bidding-summary-omit-share-empty',
  '.bidding-summary-omit-from-print-share',
  '.d-print-none',
] as const;

interface CloneBiddingSummaryExportRootOptions {
  expandSections?: boolean;
}

const copyFormValues = (source: HTMLElement, target: HTMLElement): void => {
  const sourceFields = source.querySelectorAll('textarea, input');
  const targetFields = target.querySelectorAll('textarea, input');

  sourceFields.forEach((field, index) => {
    const targetField = targetFields[index] as HTMLTextAreaElement | HTMLInputElement | undefined;
    if (!targetField) return;
    targetField.value = (field as HTMLTextAreaElement | HTMLInputElement).value;
  });
};

const stripExportArtifacts = (
  root: HTMLElement,
  { expandSections = false }: CloneBiddingSummaryExportRootOptions,
): void => {
  BIDDING_SUMMARY_EXPORT_STRIP_ICON_SELECTORS.forEach((selector) => {
    root.querySelectorAll(selector).forEach((element) => element.remove());
  });

  BIDDING_SUMMARY_EXPORT_STRIP_EXTRA_SELECTORS.forEach((selector) => {
    root.querySelectorAll(selector).forEach((element) => element.remove());
  });

  if (expandSections) {
    root.querySelectorAll('.collapse').forEach((element) => {
      element.classList.add('show');
      const htmlElement = element as HTMLElement;
      htmlElement.style.display = 'block';
      htmlElement.style.height = 'auto';
      htmlElement.style.maxHeight = 'none';
      htmlElement.style.overflow = 'visible';
      htmlElement.style.visibility = 'visible';
      htmlElement.style.opacity = '1';
    });
  }
};

export const cloneBiddingSummaryExportRoot = (
  root: HTMLElement,
  options: CloneBiddingSummaryExportRootOptions = {},
): HTMLElement => {
  const clone = root.cloneNode(true) as HTMLElement;
  copyFormValues(root, clone);
  stripExportArtifacts(clone, options);
  return clone;
};
